import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { getWorkListRecordsCount,setLastVal,setWorkListRecordsCount } from '../../../app/patientSlice';
import { VerticalTabWorkList } from '../../secondary/VerticalTabWorkList';
import style from './workListCommon.module.scss';
import { WoundPhotosData } from './woundPhotosData';
export function WoundPhotos({facilityNumber }) {
  useEffect(() => {
        dispatch(setWorkListRecordsCount({}))
        dispatch(getWorkListRecordsCount(facilityNumber,'patientSubmitedValues'));
   }, [facilityNumber])
  const workListRecordsCount = useSelector(state => state.patient.workListRecordsCount);
  const lastVal = useSelector(state => state.patient.lastVal)
  /* Tab list */
  const woundPhotosCount=workListRecordsCount?.patientSubmitedValues?.woundPhotosCount?`(${workListRecordsCount?.patientSubmitedValues?.woundPhotosCount})`:''
  const [defaultVerTab, setDefaultVerTab] = useState(lastVal?.selectVerTab ? lastVal?.selectVerTab : 0);
  const onSelectVerTab = (e) => {
    setDefaultVerTab(e);
    const setLast = { ...lastVal, selectVerTab: e };
    dispatch(setLastVal(setLast));
  };
  const tabList = [
    {
      name: `Wound Photos ${woundPhotosCount}`,
     // name: <> Wound Photos <span className={style.woundListCountSpan}>{woundPhotosCount}</span></>,
      content: <WoundPhotosData facilityNumber={facilityNumber}/>,
      bottomName: 'Pending Assessment',
      bgcolor: style.wound_photo_color
    },
  ];
  const dispatch = useDispatch();
  return (
    <>
      <VerticalTabWorkList onSelectInt={onSelectVerTab}  defaultIndex={defaultVerTab<=1?defaultVerTab:0} tabList={tabList} dispatch={dispatch} />
    </>
  )
}
